<!--
 * @Author: ezhizao 庄德政
 * @LastEditors: ezhizao 庄德政
 * @Description: 
-->
<template>
  <div class="main-container">
    <div class="page-header">
      <div class="page-title">图标列表</div>
    </div>
    <ul class="icon-list-container">
      <li v-for="(item, index) in icons" :key="index">
        <div class="icon-img"><i :class="['iconfont', item]"></i></div>
        <div class="icon-label">{{item}}</div>
      </li>
    </ul>
  </div>
</template>
<style>
.icon-list-container {
  width: 100%;
  padding: 0;
  margin: 0;
}
.icon-list-container > li {
  display: block;
  float: left;
  width: 20%;
}
.icon-list-container > li > div {
  text-align: center;
  font-size: 14px;
  padding-top: 15px;
}
.icon-list-container > li > div.icon-img > i {
  font-size: 36px;
}
.icon-list-container > li > div.icon-label {
  padding-bottom: 15px;
  border-bottom: 1px solid #ccc;
}
</style>
<script>
export default {
  name: 'Icons',
  data: () => {
    return {
      icons: [
        'icon-addressbook_fill',
        'icon-addressbook',
        'icon-barrage_fill',
        'icon-barrage',
        'icon-businesscard_fill',
        'icon-businesscard',
        'icon-camera_fill',
        'icon-camera',
        'icon-clock_fill',
        'icon-clock',
        'icon-collection_fill',
        'icon-collection',
        'icon-computer_fill',
        'icon-computer',
        'icon-coordinates_fill',
        'icon-coordinates',
        'icon-eit',
        'icon-emoji_fill',
        'icon-emoji',
        'icon-group',
        'icon-group_fill',
        'icon-headlines_fill',
        'icon-headlines',
        'icon-homepage_fill',
        'icon-homepage',
        'icon-like_fill',
        'icon-like',
        'icon-live_fill',
        'icon-live',
        'icon-lock_fill',
        'icon-lock',
        'icon-message',
        'icon-message_fill',
        'icon-mine',
        'icon-mine_fill',
        'icon-people_fill',
        'icon-people',
        'icon-picture_fill',
        'icon-picture',
        'icon-praise_fill',
        'icon-praise',
        'icon-redpacket_fill',
        'icon-redpacket',
        'icon-refresh',
        'icon-scan',
        'icon-setup_fill',
        'icon-setup',
        'icon-share_fill',
        'icon-share',
        'icon-shielding_fill',
        'icon-shielding',
        'icon-unlock_fill',
        'icon-unlock',
        'icon-search',
        'icon-searchfill',
        'icon-shop_fill',
        'icon-transaction_fill',
        'icon-shake',
        'icon-decoration_fill',
        'icon-bijibendiannao',
        'icon-bianjibiaoge',
        'icon-chizi',
        'icon-biaoqian',
        'icon-dayinji',
        'icon-baocun',
        'icon-bianji',
        'icon-daochu',
        'icon-daoru',
        'icon-diannao',
        'icon-fuzhi',
        'icon-ding',
        'icon-jianqie',
        'icon-jianpan',
        'icon-jiesuo',
        'icon-shaixuan',
        'icon-shouji',
        'icon-suoding',
        'icon-tupian',
        'icon-tianjiafujian',
        'icon-wenben',
        'icon-bangongbao',
        'icon-shu',
        'icon-wenjianjia',
        'icon-touyingyi',
        'icon-cangku_cangchuguanli',
        'icon-cangku_kucun',
        'icon-cangku_kucunxiangqing',
        'icon-cangku',
        'icon-cangku_zhongzhuanchuzhan',
        'icon-cangku_cangneishicao',
        'icon-fuwuguanli',
        'icon-fuwuliu',
        'icon-cangku_daozhan',
        'icon-cangku_kucunshuaxin',
        'icon-gongzuoliu',
        'icon-guanliyuanrenzheng',
        'icon-jinzhidengji',
        'icon-dianbiao',
        'icon-guanliyuansousuo',
        'icon-kuaisugongzuoliu',
        'icon-rengonggaichengyunshang',
        'icon-rengongbuma',
        'icon-rengonggaizhan',
        'icon-saomafuquan',
        'icon-fuwuxunhuanguanli',
        'icon-shebeidadian',
        'icon-shangjia',
        'icon-saomajiahuiche',
        'icon-shuibiao',
        'icon-shebeisousuo',
        'icon-shebeijiance',
        'icon-shuiweichuanganqi',
        'icon-tuihuochuzhan',
        'icon-xunjianweixiu',
        'icon-yemianliu',
        'icon-yichangshangbao',
        'icon-zhongkong',
        'icon-weixiufuwu',
        'icon-wenshiduchuanganqi',
        'icon-duoxuanxuanzhong',
        'icon-bofang',
        'icon-duibi',
        'icon-huojianjiasu',
        'icon-gouwudai',
        'icon-gouwu',
        'icon-danxuanweixuanzhong',
        'icon-danxuanxuanzhong',
        'icon-jiqiren',
        'icon-jinxianshibutong',
        'icon-kefu',
        'icon-lanya',
        'icon-leida-faxianx',
        'icon-lianjie',
        'icon-duoxuanweixuanzhong',
        'icon-liangliangduibi',
        'icon-quxiaolianjie',
        'icon-liangdu',
        'icon-liwu',
        'icon-shanguangdeng',
        'icon-shanguangdengzidong',
        'icon-shengyin',
        'icon-renlianshibie',
        'icon-tingzhi',
        'icon-tanhao',
        'icon-shanguangdengguanbi',
        'icon-wenhao',
        'icon-xinxi',
        'icon-shounadaohang',
        'icon-yinliang',
        'icon-yingwen',
        'icon-yuyin',
        'icon-yuechi',
        'icon-yunsuancaozuo',
        'icon-zhediedaohang',
        'icon-zhinanzhen',
        'icon-zhongwen',
        'icon-zanting',
        'icon-zhuti_yifu',
        'icon-zhendong',
        'icon-zhuti_tiaosepan',
        'icon-zhuti',
        'icon-zuanshi',
        'icon-anniu_guanbi',
        'icon-anquan',
        'icon-bangzhu',
        'icon-biaoge',
        'icon-anniu_xuanzhong',
        'icon-chexiao',
        'icon-shouye',
        'icon-duihao',
        'icon-erweima',
        'icon-caidan',
        'icon-guanbi',
        'icon-guanyu',
        'icon-cengji',
        'icon-dengyu',
        'icon-daohang',
        'icon-jiahao',
        'icon-jiazai_dan',
        'icon-jiazai_shuaxin',
        'icon-jieshaoxinxi',
        'icon-jiazai_shuang',
        'icon-jianhao',
        'icon-jinyong',
        'icon-kaiguan',
        'icon-jinggao',
        'icon-lishijilu',
        'icon-linggan',
        'icon-liebiao',
        'icon-pinleijianshao',
        'icon-pinleishanchu',
        'icon-pinleizengjia',
        'icon-kongzhizhongxin',
        'icon-shanchu',
        'icon-saoyisao',
        'icon-shipin',
        'icon-quanjushezhi',
        'icon-shitujuzhen',
        'icon-shuliang-zengjia',
        'icon-shuaxin',
        'icon-shuliangjianshao',
        'icon-tishi',
        'icon-renwuzhongxin',
        'icon-sousuo',
        'icon-tuwen',
        'icon-xinzengdaohangliebiao',
        'icon-Androidgengduo',
        'icon-iosgengduo',
        'icon-xiangji',
        'icon-yemiankuangjia',
        'icon-yingyongAPP',
        'icon-anniu_jiantoushouqi',
        'icon-anniu-jiantouxiangyou',
        'icon-jiantou_liebiaoxiangyou',
        'icon-anniu_jiantouzhankai',
        'icon-jiantou_liebiaoshouqi',
        'icon-jiantou_liebiaoxiangzuo',
        'icon-jiantou_qiehuanxiangxia',
        'icon-jiantou_liebiaozhankai',
        'icon-jiantou_qiehuanyou',
        'icon-jiantou_qiehuanxiangshang',
        'icon-jiantou_qiehuanzuo',
        'icon-jiantou_shangyiye',
        'icon-anniu_jiantouxiangzuo',
        'icon-jiantou_xiayiye',
        'icon-jiantou_xiangyou',
        'icon-jiantou_xiangzuo',
        'icon-jiantou_xiangyouliangci',
        'icon-jiantou_shangxiaqiehuan',
        'icon-jiantou_yemian_xiangshang',
        'icon-jiantou_xiangxia',
        'icon-jiantou_xiangshang',
        'icon-jiantou_xiangzuoliangci',
        'icon-jiantou_yemian_xiangxia',
        'icon-jiantou_yemian_xiangyou',
        'icon-jiantou_youshang',
        'icon-jiantou_zuoshang',
        'icon-jiantou_youxia',
        'icon-jiantou_zuoyouqiehuan',
        'icon-jiaobiaoweixuanzhong',
        'icon-jiaobiaoxuanzhong',
        'icon-moduanshouqi',
        'icon-jiantou_zuoxia',
        'icon-jiantou_yemian_xiangzuo',
        'icon-moduanzhankai',
        'icon-moduanzuoyouzhankai',
        'icon-quxiaoquanping',
        'icon-sanjiaoxing_shang',
        'icon-quanping',
        'icon-sanjiaoxing',
        'icon-moduanzuoyoushouqi',
        'icon-shangxiazhankai',
        'icon-xiazai',
        'icon-xuanzeqishouqi',
        'icon-shangchuan',
        'icon-xiangzuo',
        'icon-xuanzeqixiayige',
        'icon-xuanzeqizhankai',
        'icon-zhiding',
        'icon-dunpaibaowei',
        'icon-dunpaibaoxianrenzheng',
        'icon-huobiliu',
        'icon-dunpaibaoxianzhiliang',
        'icon-jisuanqi',
        'icon-jiekuan',
        'icon-hongbao',
        'icon-jinbi',
        'icon-cunkuan',
        'icon-meiyuan',
        'icon-qianbao',
        'icon-yinhangqia',
        'icon-zhangdan_kong',
        'icon-zhangdan_xiangqing',
        'icon-zhangdan_quxiao',
        'icon-zhangdan_xinzeng',
        'icon-jinrongguanli',
        'icon-zhangdan-wancheng',
        'icon-zhangdan',
        'icon-zhibi_renminbi',
        'icon-renminbi',
        'icon-zijin_dongjie',
        'icon-zijin',
        'icon-zijinxunhuan',
        'icon-anniucai',
        'icon-cai',
        'icon-biaoqing',
        'icon-anniu-zan',
        'icon-biaoqing_xiao',
        'icon-chengchang',
        'icon-dianhua',
        'icon-duanxin',
        'icon-gerentouxiang',
        'icon-fenxiang',
        'icon-qiandao',
        'icon-qunzu',
        'icon-biaoqing_beishang',
        'icon-shoucang',
        'icon-tianjiahaoyou',
        'icon-wangwanglikai',
        'icon-xiai',
        'icon-zan',
        'icon-wangwang',
        'icon-daibanrenwu_quxiao',
        'icon-daibanrenwu',
        'icon-naozhong',
        'icon-shijian',
        'icon-riqi',
        'icon-rili',
        'icon-shuzhuangtu',
        'icon-yun',
        'icon-bingtu',
        'icon-yunshangchuan',
        'icon-yunxiazai',
        'icon-zhexiantu',
        'icon-zhuzhuangtu',
        'icon-baoguo_lanshou',
        'icon-baoguo_dabao',
        'icon-baoguo_huanbaohe',
        'icon-baoguo_dakai',
        'icon-baoguo_hezi',
        'icon-baoguo_lingjian',
        'icon-baoguo_shounahe',
        'icon-baoguo_tihuoduanxin',
        'icon-baoguo_quxiaoshouhuo',
        'icon-baoguo_shouhuo',
        'icon-baoguo_yidong',
        'icon-che',
        'icon-didiandingwei',
        'icon-ditu_diqiu',
        'icon-baoguo_fahuo',
        'icon-ditu',
        'icon-ditu_dingwei',
        'icon-feiji_qifei',
        'icon-baoguo',
        'icon-gouwuche',
        'icon-gaojijibao',
        'icon-fenjianguocheng',
        'icon-feiji_jiangla',
        'icon-guizi',
        'icon-huoche_zhuangche',
        'icon-huoche_quxiaozhuangche',
        'icon-huoche',
        'icon-haiguan',
        'icon-fuwu',
        'icon-jiankong',
        'icon-jibao',
        'icon-jianzhu',
        'icon-jiancha',
        'icon-jingliren',
        'icon-paijian',
        'icon-huopinfenliu',
        'icon-quxiaojibao',
        'icon-kuaidiyuan',
        'icon-sandengfen',
        'icon-shijuedingwei',
        'icon-wuliudanao',
        'icon-tousu',
        'icon-kuaidiyuanguanli',
        'icon-yizhan',
        'icon-yizhanxiangqing',
        'icon-sidengfen',
        'icon-CPhezuo',
        'icon-PDA',
        'icon-xiangsishangpin',
        'icon-yibiaopan',
        'icon-duanxinqunfa',
        'icon-xiaoxi',
        'icon-xinwen',
        'icon-tongzhizhongxin',
        'icon-youjian',
        'icon-dengchu',
        'icon-gerenxinxi',
        'icon-anniu_gerenzhongxin',
        'icon-yanjing_yincang',
        'icon-yanjing_xianshi',
        'icon-baocun_o',
        'icon-biaoqian_o',
        'icon-bianjibiaoge_o',
        'icon-dayinji_o',
        'icon-chizi_o',
        'icon-bangongbao_o',
        'icon-daoru_o',
        'icon-diannao_o',
        'icon-bianji_o',
        'icon-bijibendiannao_o',
        'icon-ding_o',
        'icon-jianpan_o',
        'icon-jianqie_o',
        'icon-shaixuan_o',
        'icon-jiesuo_o',
        'icon-daochu_o',
        'icon-shouji_o',
        'icon-tianjiafujian_o',
        'icon-shu_o',
        'icon-fuzhi_o',
        'icon-wenben_o',
        'icon-touyingyi_o',
        'icon-wenjianjia_o',
        'icon-tupian_o',
        'icon-suoding_o',
        'icon-cangku_kucunxiangqing_o',
        'icon-cangku_daozhan_o',
        'icon-cangku_kucun_o',
        'icon-cangku_cangchuguanli_o',
        'icon-cangku_kucunshuaxin_o',
        'icon-cangku_cangneishicao_o',
        'icon-cangku_o',
        'icon-dianbiao_o',
        'icon-cangku_zhongzhuanchuzhan_o',
        'icon-fuwuliu_o',
        'icon-fuwuguanli_o',
        'icon-gongzuoliu_o',
        'icon-fuwuxunhuanguanli_o',
        'icon-guanliyuanrenzheng_o',
        'icon-jinzhidengji_o',
        'icon-kuaisugongzuoliu_o',
        'icon-rengongbuma_o',
        'icon-rengonggaichengyunshang_o',
        'icon-rengonggaizhan_o',
        'icon-saomafuquan_o',
        'icon-guanliyuansousuo_o',
        'icon-shangjia_o',
        'icon-shebeijiance_o',
        'icon-shebeisousuo_o',
        'icon-shuibiao_o',
        'icon-saomajiahuiche_o',
        'icon-tuihuochuzhan_o',
        'icon-shebeidadian_o',
        'icon-wenshiduchuanganqi_o',
        'icon-shuiweichuanganqi_o',
        'icon-yichangshangbao_o',
        'icon-xunjianweixiu_o',
        'icon-yemianliu_o',
        'icon-weixiufuwu_o',
        'icon-zhongkong_o',
        'icon-danxuanweixuanzhong_o',
        'icon-bofang_o',
        'icon-duoxuanweixuanzhong_o',
        'icon-duibi_o',
        'icon-duoxuanxuanzhong_o',
        'icon-eyu_o',
        'icon-gouwudai_o',
        'icon-gouwu_o',
        'icon-huojianjiasu_o',
        'icon-jiqiren_o',
        'icon-kefu_o',
        'icon-lanya_o',
        'icon-shengyin_o',
        'icon-leida-faxian_o',
        'icon-danxuanxuanzhong_o',
        'icon-lianjie_o',
        'icon-liwu_o',
        'icon-liangdu_o',
        'icon-liangliangduibi_o',
        'icon-renlianshibie_o',
        'icon-quxiaolianjie_o',
        'icon-jinxianshibutong_o',
        'icon-shanguangdeng_o',
        'icon-shanguangdengzidong_o',
        'icon-shanguangdengguanbi_o',
        'icon-tanhao_o',
        'icon-wenhao_o',
        'icon-xinxi_o',
        'icon-tingzhi_o',
        'icon-yuechi_o',
        'icon-yinliang_o',
        'icon-yingwen_o',
        'icon-yuyin_o',
        'icon-yunsuancaozuo_o',
        'icon-zanting_o',
        'icon-shounadaohang_o',
        'icon-zhediedaohang_o',
        'icon-zhendong_o',
        'icon-zhuti_tiaosepan_o',
        'icon-zhuti_yifu_o',
        'icon-zhuti_o',
        'icon-zuanshi_o',
        'icon-zhongwen_o',
        'icon-zhinanzhen_o',
        'icon-anquan_o',
        'icon-caidan_o',
        'icon-anniu_xuanzhong_o',
        'icon-bangzhu_o',
        'icon-cengji_o',
        'icon-chexiao_o',
        'icon-daohang_o',
        'icon-duihao_o',
        'icon-anniu_guanbi_o',
        'icon-erweima_o',
        'icon-Androidgengduo_o',
        'icon-guanbi_o',
        'icon-biaoge_o',
        'icon-guanyu_o',
        'icon-jiahao_o',
        'icon-dengyu_o',
        'icon-jiazai_shuang_o',
        'icon-jianhao_o',
        'icon-jieshaoxinxi_o',
        'icon-kaiguan_o',
        'icon-jiazai_dan_o',
        'icon-jiazai_shuaxin_o',
        'icon-lishijilu_o',
        'icon-liebiao_o',
        'icon-linggan_o',
        'icon-jinyong_o',
        'icon-pinleishanchu_o',
        'icon-pinleijianshao_o',
        'icon-kongzhizhongxin_o',
        'icon-pinleizengjia_o',
        'icon-renwuzhongxin_o',
        'icon-quanjushezhi_o',
        'icon-jinggao_o',
        'icon-saoyisao_o',
        'icon-shipin_o',
        'icon-shouye_o',
        'icon-shuliang-zengjia_o',
        'icon-shuaxin_o',
        'icon-shanchu_o',
        'icon-tishi_o',
        'icon-tuwen_o',
        'icon-shitujuzhen_o',
        'icon-xinzengdaohangliebiao_o',
        'icon-sousuo_o',
        'icon-shuliangjianshao_o',
        'icon-yemiankuangjia_o',
        'icon-iosgengduo_o',
        'icon-xiangji_o',
        'icon-yingyongAPP_o',
        'icon-anniu_jiantoushouqi_o',
        'icon-anniu_jiantouxiangzuo_o',
        'icon-anniu_jiantouzhankai_o',
        'icon-jiantou_liebiaoshouqi_o',
        'icon-jiantou_liebiaoxiangyou_o',
        'icon-jiantou_liebiaozhankai_o',
        'icon-jiantou_qiehuanxiangxia_o',
        'icon-anniu-jiantouxiangyou_o',
        'icon-jiantou_qiehuanyou_o',
        'icon-xuanzeqizhankai_o',
        'icon-jiantou_qiehuanxiangshang_o',
        'icon-jiantou_zuoshang_o',
        'icon-jiantou_liebiaoxiangzuo_o',
        'icon-jiantou_shangyiye_o',
        'icon-jiantou_xiayiye_o',
        'icon-jiantou_xiangshang_o',
        'icon-jiantou_xiangxia_o',
        'icon-jiantou_xiangyouliangci_o',
        'icon-jiantou_shangxiaqiehuan_o',
        'icon-jiantou_qiehuanzuo_o',
        'icon-jiantou_xiangzuo_o',
        'icon-jiantou_yemian_xiangshang_o',
        'icon-jiantou_xiangzuoliangci_o',
        'icon-jiantou_yemian_xiangyou_o',
        'icon-jiantou_youshang_o',
        'icon-jiantou_xiangyou_o',
        'icon-jiantou_yemian_xiangzuo_o',
        'icon-jiantou_youxia_o',
        'icon-jiantou_zuoyouqiehuan_o',
        'icon-jiantou_yemian_xiangxia_o',
        'icon-jiaobiaoweixuanzhong_o',
        'icon-moduanzuoyoushouqi_o',
        'icon-jiantou_zuoxia_o',
        'icon-quxiaoquanping_o',
        'icon-moduanshouqi_o',
        'icon-jiaobiaoxuanzhong_o',
        'icon-moduanzhankai_o',
        'icon-moduanzuoyouzhankai_o',
        'icon-sanjiaoxing_shang_o',
        'icon-quanping_o',
        'icon-xiangzuo_o',
        'icon-shangxiazhankai_o',
        'icon-xuanzeqishouqi_o',
        'icon-xuanzeqixiayige_o',
        'icon-sanjiaoxing_o',
        'icon-shangchuan_o',
        'icon-xiazai_o',
        'icon-zhiding_o',
        'icon-dunpaibaowei_o',
        'icon-huobiliu_o',
        'icon-hongbao_o',
        'icon-dunpaibaoxianzhiliang_o',
        'icon-jiekuan_o',
        'icon-jisuanqi_o',
        'icon-jinrongguanli_o',
        'icon-cunkuan_o',
        'icon-dunpaibaoxianrenzheng_o',
        'icon-qianbao_o',
        'icon-jinbi_o',
        'icon-meiyuan_o',
        'icon-renminbi_o',
        'icon-zhangdan_quxiao_o',
        'icon-zhangdan_kong_o',
        'icon-zhangdan_xinzeng_o',
        'icon-zhangdan-wancheng_o',
        'icon-zijin_dongjie_o',
        'icon-zhangdan_o',
        'icon-yinhangqia_o',
        'icon-zijin_o',
        'icon-zijinxunhuan_o',
        'icon-zhangdan_xiangqing_o',
        'icon-zhibi_renminbi_o',
        'icon-anniu-zan_o',
        'icon-anniucai_o',
        'icon-biaoqing_xiao_o',
        'icon-chengchang_o',
        'icon-duanxin_o',
        'icon-biaoqing_beishang_o',
        'icon-cai_o',
        'icon-fenxiang_o',
        'icon-biaoqing_o',
        'icon-gerentouxiang_o',
        'icon-qiandao_o',
        'icon-qunzu_o',
        'icon-dianhua_o',
        'icon-tianjiahaoyou_o',
        'icon-shoucang_o',
        'icon-wangwang_o',
        'icon-xiai_o',
        'icon-zan_o',
        'icon-wangwanglikai_o',
        'icon-naozhong_o',
        'icon-shijian_o',
        'icon-riqi_o',
        'icon-daibanrenwu_o',
        'icon-rili_o',
        'icon-daibanrenwu_quxiao_o',
        'icon-shuzhuangtu_o',
        'icon-zhexiantu_o',
        'icon-yun_o',
        'icon-yunshangchuan_o',
        'icon-yunxiazai_o',
        'icon-bingtu_o',
        'icon-zhuzhuangtu_o',
        'icon-baoguo_fahuo_o',
        'icon-baoguo_dakai_o',
        'icon-baoguo_hezi_o',
        'icon-baoguo_dabao_o',
        'icon-baoguo_huanbaohe_o',
        'icon-baoguo_quxiaoshouhuo_o',
        'icon-baoguo_shouhuo_o',
        'icon-baoguo_lingjian_o',
        'icon-baoguo_shouna_o',
        'icon-baoguo_tihuoduanxin_o',
        'icon-baoguo_o',
        'icon-baoguo_lanshou_o',
        'icon-che_o',
        'icon-didiandingwei_o',
        'icon-baoguo_yidong_o',
        'icon-ditu_dingwei_o',
        'icon-ditu_diqiu_o',
        'icon-feiji_jiangla_o',
        'icon-ditu_o',
        'icon-fenjianguocheng_o',
        'icon-feiji_qifei_o',
        'icon-fuwu_o',
        'icon-gaojijibao_o',
        'icon-guizi_o',
        'icon-gouwuche_o',
        'icon-huoche_quxiaozhuangche_o',
        'icon-huoche_zhuangche_o',
        'icon-huoche_o',
        'icon-haiguan_o',
        'icon-huopinfenliu_o',
        'icon-jiankong_o',
        'icon-jiancha_o',
        'icon-kuaidiyuan_o',
        'icon-jianzhu_o',
        'icon-kuaidiyuanguanli_o',
        'icon-jibao_o',
        'icon-sandengfen_o',
        'icon-shijuedingwei_o',
        'icon-jingliren_o',
        'icon-paijian_o',
        'icon-sidengfen_o',
        'icon-tousu_o',
        'icon-quxiaojibao_o',
        'icon-wuliudanao_o',
        'icon-yizhan_o',
        'icon-yizhanxiangqing_o',
        'icon-xiangsishangpin_o',
        'icon-PDA_o',
        'icon-CPhezuo_o',
        'icon-yibiaopan_o',
        'icon-duanxinqunfa_o',
        'icon-xinwen_o',
        'icon-xiaoxi_o',
        'icon-youjian_o',
        'icon-tongzhizhongxin_o',
        'icon-dengchu_o',
        'icon-yanjing_xianshi_o',
        'icon-gerenxinxi_o',
        'icon-yanjing_yincang_o',
        'icon-anniu_gerenzhongxin_o'
      ]
    }
  }
}
</script>